<itb-heading mat-dialog-title [className]="'modal-h'" [text]="data.title" ></itb-heading>
<itb-round-button [tooltipText]="'Close'" mat-dialog-close [className]="'light round-modal-cross caret-close-modal'" [iconClassName]="'cross'"></itb-round-button>
<div mat-dialog-content>
  <p *ngIf="!hasInnerHTML">{{data.body}}</p>
  <p *ngIf="hasInnerHTML" [innerHTML]="data.body"></p>
</div>
<!-- <itb-action-panel [btnArray]="data.buttonsArray" [mat-dialog-close]="name" (onClickHandler)="btnClick($event)">
</itb-action-panel> -->

<mat-dialog-actions align="end">
<itb-default-button [mat-dialog-close]="name" *ngFor="let btn of data.buttonsArray" [iconClassName]="btn.iconClassName" [isHidden]="btn.isHidden" [isDisabled]="btn.isDisabled" [className]="btn.className" [isLoading]="btn.isLoading" [text]="btn.text" (onClickHandler)="btnClick(btn.buttonName)"></itb-default-button>
</mat-dialog-actions>
